import React from 'react'

export default function MembershipTitle(props) {
  const {title, subtitle, subtitleInfo} = props;

  return (
    <section className="row title-page text-center">
      <div className="col-sm-12">

        <h1 className="text-uppercase font-weight-bold">{ title }</h1>

        {!props.membershipType && (
          <h4 className="text-uppercase font-weight-bold text-primary">
            { subtitle }
          </h4>
        )}

        <p className="text-muted">{ subtitleInfo }</p>
      </div>
    </section>
  )
}
